import * as React from 'react';
import cn from 'classnames';
import { Variants, motion } from 'framer-motion';

import { ComponentType } from 'shared/entities/components/Component';
import { useTypedTranslation } from 'shared/entities/localization';
import { Button } from 'shared/newComponents/buttons';
import { ButtonColor, ButtonSize } from 'shared/newEntities/components/Button';

import './StepFooter.modules.scss';

type Props = {
  chunkVariants: Variants;
  primaryLabel: string;
  primaryDisabled: boolean;
  primaryLoading: boolean;
  skipLoading: boolean;
  disabled: boolean;
  onPrimary: () => void;
  onSkip: () => void;
  /** Есть только на шагах с вопросами: с первого шага возвращаться некуда */
  onBack?: () => void;
};

const StepFooter: React.FC<Props> = ({
  chunkVariants,
  primaryLabel,
  primaryDisabled,
  primaryLoading,
  skipLoading,
  disabled,
  onPrimary,
  onSkip,
  onBack
}: Props) => {
  const { t } = useTypedTranslation('app');

  return (
    <motion.footer
      variants={chunkVariants}
      styleName={cn('step-footer', !onBack && 'step-footer_without-back')}
    >
      {onBack && (
        <Button
          type={ComponentType.button}
          color={ButtonColor.lightBlue}
          size={ButtonSize.md}
          disabled={disabled}
          onClick={onBack}
          styleName="step-footer__back"
        >
          {t('managerSegment.actions.back')}
        </Button>
      )}
      <div styleName="step-footer__actions">
        <Button
          type={ComponentType.button}
          color={ButtonColor.lightBlue}
          size={ButtonSize.md}
          isLoading={skipLoading}
          disabled={disabled}
          onClick={onSkip}
          styleName="step-footer__main-action"
        >
          {t('managerSegment.actions.skip')}
        </Button>
        <Button
          type={ComponentType.button}
          size={ButtonSize.md}
          isLoading={primaryLoading}
          disabled={primaryDisabled}
          onClick={onPrimary}
          styleName="step-footer__main-action"
        >
          {primaryLabel}
        </Button>
      </div>
    </motion.footer>
  );
};

export default React.memo(StepFooter);
